import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import { Dialog, Table } from 'components';

const columns = [{ label: 'DI' }, { label: 'Subcategoria' }, { label: 'Descrição da Falha' }];

export const DialogFailureDiagnostics = ({ open, onClose, failures, numeroOs }) => {
  const list = failures || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md'>
      <Dialog.Title onClose={onClose}>Defeitos apontados pelo TCoM — OS {numeroOs}</Dialog.Title>
      <Dialog.Content>
        <Typography variant='body2' color='textSecondary' gutterBottom>
          Estas falhas foram lançadas como Informação Adicional na OS.
        </Typography>
        <Table headers={columns} disableNumeration maxHeight>
          {list.map((failure, index) => (
            <TableRow key={`${failure.FalhaDI}-${index}`}>
              <TableCell>{failure.FalhaDI}</TableCell>
              <TableCell>{failure.SubCategoria || '-'}</TableCell>
              <TableCell>{failure.DescricaoFalha || '-'}</TableCell>
            </TableRow>
          ))}
        </Table>
      </Dialog.Content>
    </Dialog>
  );
};
